import React from "react";
import {Race} from "../../../schemas/races/racesSchema";
import {Stack} from "@mui/material";
import RaceDetailsOverview from "./RaceDetailsOverview";
import dayjs from "dayjs";
import EmptyRacesState from "../overview/EmptyRacesState";

interface RacesDetailsListProps {
    races: Race[] | undefined;
}

const RacesDetailsList: React.FC<RacesDetailsListProps> = ({races}) => {
    const publicRaces = races?.filter(race => race.publishStatus === "PUBLISHED") || [];
    const publicSortedRaces = publicRaces.sort((r1, r2) => {
        const date1 = dayjs(r1.date);
        const date2 = dayjs(r2.date);
        return date1.isAfter(date2) ? -1 : date1.isBefore(date2) ? 1 : 0;
    });

    return (
        publicSortedRaces.length === 0 ? (
            <EmptyRacesState/>
        ) : (
            <Stack spacing={2}>
                {publicSortedRaces.map(race => <RaceDetailsOverview key={race.id} race={race}/>)}
            </Stack>
        )
    );
}

export default RacesDetailsList;